"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasEngine = void 0;
const tsyringe_1 = require("tsyringe");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const Canvas_1 = require("./Canvas");
let CanvasEngine = class CanvasEngine {
    constructor() {
        // #region Properties (4)
        this._canvasDictionary = {};
        this._uuidGenerator = tsyringe_1.container.resolve(viewer_shared_services_1.UuidGenerator);
        // #endregion Public Methods (2)
    }
    // #endregion Properties (4)
    // #region Public Methods (2)
    /**
     * Creates a canvas object that could in the future be expanded to hold more information
     * The definition of the canvas can be:
     * - empty: A canvas is created with an unique ID.
     * - string:
     *      - If a canvas with this ID was created, this canvas is returned.
     *      - If there is an HTMLCanvasElement in the document with this ID, this is used.
     *      - If there is no HTMLElement found in the document with this ID, a canvas with ID will be created.
     * - HTMLCanvasElement: A Canvas Object will be created with this element. If there is no ID, one will be generated.
     *
     * @param canvasDefinition the definition of this canvas
     */
    createCanvasObject(canvasDefinition, storageId) {
        storageId = storageId !== undefined && this._uuidGenerator.validate(storageId) ? storageId : this._uuidGenerator.create();
        if (canvasDefinition instanceof HTMLCanvasElement) {
            // a canvas was provided
            const canvasElement = canvasDefinition;
            if (!canvasElement.id)
                canvasElement.id = this._uuidGenerator.create();
            this._canvasDictionary[storageId] = new Canvas_1.Canvas(canvasElement.id, canvasDefinition, canvasElement);
            return storageId;
        }
        if (canvasDefinition) {
            const id = canvasDefinition;
            const canvasElement = document.getElementById(id);
            for (let canvasId in this._canvasDictionary)
                if (this._canvasDictionary[canvasId].id === id)
                    return canvasId;
            if (canvasElement instanceof HTMLCanvasElement) {
                // id of a canvas was provided
                this._canvasDictionary[storageId] = new Canvas_1.Canvas(id, canvasDefinition, canvasElement);
                return storageId;
            }
            else if (!canvasElement) {
                // no HTMLElement could be found, create Canvas with the id
                this._canvasDictionary[storageId] = new Canvas_1.Canvas(id, canvasDefinition);
                return storageId;
            }
        }
        this._canvasDictionary[storageId] = new Canvas_1.Canvas(storageId, canvasDefinition);
        return storageId;
    }
    getCanvas(storageId) {
        return this._canvasDictionary[storageId];
    }
};
CanvasEngine = __decorate([
    tsyringe_1.singleton()
], CanvasEngine);
exports.CanvasEngine = CanvasEngine;
//# sourceMappingURL=CanvasEngine.js.map